import { List, Datagrid, TextField } from "react-admin";

import PhoneField from "../components/PhoneField";
import LayoutContainer from "../components/LayoutContainer";
import useDataGridStyles from "../components/DataGridStyle";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";
import exporter from "../../../utils/exporter";
import CustomAction from "../components/CustomAction";
import CustomDateField from "../components/CustomDateField";

const BranchList = (props) => {
  const title = "Branches";
  const headers = [
    { label: "Branch Name", source: "name" },
    { label: "Address", source: "address" },
    { label: "Phone", source: "phone" },
    { label: "Created", source: "time" },
  ];
  const classes = useDataGridStyles();
  return (
    <LayoutContainer>
      <SfBreadcrumbs path="Management/Branches" lower />
      <List
        {...props}
        //filters={<ProductFilter />}
        perPage={10}
        bulkActionButtons={false}
        exporter={(data) => exporter(data, headers, title)}
        actions={<CustomAction labelCreate="Add Branch" />}
        classes={{ content: classes.content }}
      >
        <Datagrid
          rowClick="show"
          classes={{ headerCell: classes.header, rowCell: classes.row }}
        >
          <TextField label="Branch Name" source="name" />
          <TextField label="Address" source="address" />
          <PhoneField label="Phone" source="phone" />

          <CustomDateField label="Created" source="time" />
        </Datagrid>
      </List>
      <PermissionChecker code="Page.Merchant.Management.Branch" />
    </LayoutContainer>
  );
};

export default BranchList;
